import React, { FC, PropsWithChildren } from 'react';
import styles from './MobileDevice.scss';

export const MobileDevice: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.mobileDevice}>
      <div className={styles.mobileDeviceKnob} />
      <div className={styles.mobileDeviceContent}>{children}</div>
    </div>
  );
};
